<template>
    <form id="onboarding-de" class="wrapper" role="form" method="post" @submit.prevent="submit" novalidate autocomplete="off">
        <div class="bmi-stats-wrapper">
            <span class="headline-lg">Ihr BMI ist <strong :class="'hedaline-xlg text-'+getBMIstatus.color">{{ getBMI.replace('.', ',') }}</strong></span>

            <div class="bmi-stats">
                <ul class="no-list-style">
                    <li :class="['stats-item--blue-light', {'active' : getBMIstatus.status === 'underweight'}]">
                        <span class="stats-line"></span>
                        <span class="stats-label text-blue-light">Untergewicht</span>
                    </li>

                    <li :class="['stats-item--green', {'active' : getBMIstatus.status === 'normal'}]">
                        <span class="stats-line"></span>
                        <span class="stats-label text-green">Normal</span>
                    </li>

                    <li :class="['stats-item--orange', {'active' : getBMIstatus.status === 'overweight'}]">
                        <span class="stats-line"></span>
                        <span class="stats-label text-orange">Übergewicht</span>
                    </li>

                    <li :class="['stats-item--red', {'active' : getBMIstatus.status === 'obese'}]">
                        <span class="stats-line"></span>
                        <span class="stats-label text-red">Adipositas</span>
                    </li>
                </ul>

                <a href="#" data-target="#modal-quiz-bmi" data-toggle="modal" data-dismiss="modal" class="text-bold">Was sagt diese Zahl aus?</a>
            </div>
        </div>

        <header>
            <span class="headline-md text-violet">{{ getHeadlineText }}</span>

            <p>Geben Sie Ihre E-Mail-Adresse ein, um fortzufahren.</p>
        </header>

        <div>
            <form-input-type-email
                name="email"
                label="E-Mail-Adresse"
                :errors="errors.email"
                required
                full-border
            ></form-input-type-email>

            <form-input-type-checkbox
                name="agreements"
                label='Ich akzeptiere die <a href="/datenschutzerklarung" target="_blank">Datenschutzrichtlinien</a>.'
                :errors="errors.agreements"
                required
            ></form-input-type-checkbox>

            <v-button type="submit" label="Weiter" size="lg" full-width></v-button>

            <figure>
                <img src="/imgs/web/img_onboarding.webp" srcset="/imgs/web/img_onboarding.webp 1, /imgs/web/img_onboarding@2x.webp 2x" alt="">
            </figure>
        </div>
    </form>
</template>

<script>
    export default {
        props: {
            data: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                errors: {},
                hideDatetime: false,
                token: null,
                slots: null,
                client: null,
                date: null,
                daktelaCalls: null
            }
        },

        mounted() {
        },

        computed: {
            getBMI() {
                return (this.data.weight / ((this.data.height * this.data.height)  / 10000)).toFixed(1)
            },
            getBMIstatus() {
                if(this.getBMI < 18.5) {
                    return {
                        status: "underweight",
                        color: "blue-light",
                        label: "Untergewicht"
                    }
                }

                if(this.getBMI < 24.99) {
                    return {
                        status: "normal",
                        color: "green",
                        label: "Normal"
                    }
                }

                if(this.getBMI < 29.99) {
                    return {
                        status: "overweight",
                        color: "orange",
                        label: "Übergewicht"
                    }
                }

                if(this.getBMI >= 30) {
                    return {
                        status: "obese",
                        color: "red",
                        label: "Adipositas"
                    }
                }
            },
            getHeadlineText() {
                switch (this.data.motivation) {
                    case 'Abnehmen':
                        return 'Vitadio unterstützt Sie beim Abnehmen durch einen gesünderen Lebensstil';
                    
                    case 'Blutzucker unter Kontrolle haben':
                        return 'Vitadio unterstützt Sie dabei, Ihren Blutzucker im Griff zu behalten';

                    case 'Über Ernährung lernen':
                        return 'Vitadio hilft Ihnen dabei, alles über Ernährung zu lernen - einfach und verständlich';

                    case 'Unterstützung durch Gleichgesinnte erhalten':
                        return 'Vitadio bietet Ihnen Austausch mit der Community denn gemeinsam ist es leichter';

                    case 'Allgemeine Gesundheit verbessern':
                        return 'Vitadio unterstützt Sie dabei, Ihre Gesundheit zu verbessern';
                
                    default:
                        break;
                }
            }
        },

        methods: {
            submit() {
                this.data.email = $("#email").val()
                this.data.agreements = $("#agreements").is(":checked")
                this.data.variant = "B"
                this.data.ga_client_id = null
                
                let gaCookie = window.getCookie("_ga")

                if(gaCookie !== "" || gaCookie !== "undefined") {
                    this.data.ga_client_id = gaCookie
                }

                axios
                    .post('api/web_pre_registration_form/', this.data, {
                        headers: {
                            'Accept-Language': 'de'
                        }
                    })
                    .then((e) => {
                        window.dataLayer.push({
                            'event': 'pre_registration_web',
                            'conversion': 'E-mail received'
                        })

                        setTimeout(() => {
                            this.$emit('clicked', e.data)
                        }, 250);
                    })
                    .catch((e) => {
                        this.errors = e.response.data.errors
                        console.log(e.response)
                        Vuemit.fire('Button--sending-failed', true) 
                    })
            }
        }
    }
</script>